import { useState } from 'react';
import {
  Button,
  Grid,
  CircularProgress,
  Box,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { WeekType } from 'src/types/domain.types';
import { useScoreContestMutation } from 'src/api/contests/scoreContest';

export default function ContestScoreDialog(props: any) {
  const [contestWeekId, setContestWeekId] = useState<number>(-1);

  const { mutateAsync: scoreContestMutation, isPending } =
    useScoreContestMutation();

  const onCancel = () => {
    props.onClose();
  };

  const handleChangeWeek = (event: any) => {
    setContestWeekId(event.target.value);
  };

  const handleScore = () =>
    scoreContestMutation({
      contestId: props.contestId,
      contestWeekId: contestWeekId,
    });

  return (
    <>
      <Dialog
        open={true}
        onClose={() => {}}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
        fullWidth
        maxWidth='sm'
      >
        <DialogTitle id='alert-dialog-title'>Score Contest</DialogTitle>
        <DialogContent>
          {isPending ? (
            <Box
              sx={{ display: 'flex', justifyContent: 'center' }}
              style={{ padding: 20 }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <Grid container spacing={3}>
              <Grid item xs={12} sx={{ mt: 2 }}>
                <FormControl fullWidth>
                  <InputLabel id='status-select-label'>Rounds</InputLabel>
                  <Select
                    labelId='status-label'
                    id='status-select'
                    value={contestWeekId}
                    label='Type'
                    onChange={handleChangeWeek}
                  >
                    {props.weeks.map((week: WeekType) => (
                      <MenuItem value={week.contest_week_id}>
                        {week.name_en}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => onCancel()}>Cancel</Button>
          <Button onClick={() => handleScore()} autoFocus disabled={false}>
            Score
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
